
import { supabase } from '../client';
import { SocialProfile, DbResponse } from './types';

// Function to retrieve social profiles for an organization
export const getSocialProfiles = async (organizationId: string): Promise<DbResponse<SocialProfile[]>> => {
  console.log(`Récupération des profils sociaux pour l'organisation: ${organizationId}`);
  try {
    const { data, error } = await supabase
      .from('social_profiles')
      .select('*')
      .eq('organization_id', organizationId);
    
    if (error) {
      console.error('Erreur lors de la récupération des profils sociaux:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Profils sociaux récupérés avec succès:', data);
    return { success: true, data };
  } catch (err) {
    console.error('Exception lors de la récupération des profils sociaux:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Erreur inconnue' };
  }
};

// Function to add a social profile
export const addSocialProfile = async (profileData: Omit<SocialProfile, 'id' | 'created_at' | 'updated_at'>): Promise<DbResponse<SocialProfile>> => {
  try {
    // Ajouter les logs pour le débogage
    console.log("Ajout d'un profil social avec les données:", profileData);
    
    const { data, error } = await supabase
      .from('social_profiles')
      .insert(profileData)
      .select()
      .single();
    
    if (error) {
      console.error('Erreur lors de l\'ajout du profil social:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Profil social ajouté avec succès:', data);
    return { success: true, data };
  } catch (err) {
    console.error('Exception lors de l\'ajout du profil social:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Erreur inconnue' };
  }
};

// Function to delete a social profile
export const deleteSocialProfile = async (profileId: string): Promise<DbResponse<void>> => {
  try {
    const { error } = await supabase
      .from('social_profiles')
      .delete()
      .eq('id', profileId);
    
    if (error) {
      console.error('Erreur lors de la suppression du profil social:', error);
      return { success: false, error: error.message };
    }
    
    console.log('Profil social supprimé avec succès');
    return { success: true };
  } catch (err) {
    console.error('Exception lors de la suppression du profil social:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Erreur inconnue' };
  }
};
